import {
  AtomicAriaLive as LitAtomicAriaLive,
  AtomicAutomaticFacet as LitAtomicAutomaticFacet,
  AtomicAutomaticFacetGenerator as LitAtomicAutomaticFacetGenerator,
  AtomicBreadbox as LitAtomicBreadbox,
  AtomicCategoryFacet as LitAtomicCategoryFacet,
  AtomicColorFacet as LitAtomicColorFacet,
  AtomicComponentError as LitAtomicComponentError,
  AtomicDidYouMean as LitAtomicDidYouMean,
  AtomicExternal as LitAtomicExternal,
  AtomicFacet as LitAtomicFacet,
  AtomicFacetManager as LitAtomicFacetManager,
  AtomicFocusTrap as LitAtomicFocusTrap,
  AtomicFoldedResultList as LitAtomicFoldedResultList,
  AtomicFormatCurrency as LitAtomicFormatCurrency,
  AtomicFormatNumber as LitAtomicFormatNumber,
  AtomicFormatUnit as LitAtomicFormatUnit,
  AtomicGeneratedAnswer as LitAtomicGeneratedAnswer,
  AtomicGeneratedAnswerFeedbackModal as LitAtomicGeneratedAnswerFeedbackModal,
  AtomicHtml as LitAtomicHtml,
  AtomicIcon as LitAtomicIcon,
  AtomicLayoutSection as LitAtomicLayoutSection,
  AtomicLoadMoreResults as LitAtomicLoadMoreResults,
  AtomicNoResults as LitAtomicNoResults,
  AtomicNotifications as LitAtomicNotifications,
  AtomicNumericFacet as LitAtomicNumericFacet,
  AtomicNumericRange as LitAtomicNumericRange,
  AtomicPager as LitAtomicPager,
  AtomicPopover as LitAtomicPopover,
  AtomicQueryError as LitAtomicQueryError,
  AtomicQuerySummary as LitAtomicQuerySummary,
  AtomicQuickview as LitAtomicQuickview,
  AtomicQuickviewModal as LitAtomicQuickviewModal,
  AtomicRatingFacet as LitAtomicRatingFacet,
  AtomicRatingRangeFacet as LitAtomicRatingRangeFacet,
  AtomicRecsError as LitAtomicRecsError,
  AtomicRecsInterface as LitAtomicRecsInterface,
  AtomicRecsList as LitAtomicRecsList,
  AtomicRecsResult as LitAtomicRecsResult,
  AtomicRefineModal as LitAtomicRefineModal,
  AtomicRefineToggle as LitAtomicRefineToggle,
  AtomicResult as LitAtomicResult,
  AtomicResultBadge as LitAtomicResultBadge,
  AtomicResultChildren as LitAtomicResultChildren,
  AtomicResultChildrenTemplate as LitAtomicResultChildrenTemplate,
  AtomicResultDate as LitAtomicResultDate,
  AtomicResultFieldsList as LitAtomicResultFieldsList,
  AtomicResultHtml as LitAtomicResultHtml,
  AtomicResultIcon as LitAtomicResultIcon,
  AtomicResultImage as LitAtomicResultImage,
  AtomicResultLink as LitAtomicResultLink,
  AtomicResultList as LitAtomicResultList,
  AtomicResultLocalizedText as LitAtomicResultLocalizedText,
  AtomicResultMultiValueText as LitAtomicResultMultiValueText,
  AtomicResultNumber as LitAtomicResultNumber,
  AtomicResultPrintableUri as LitAtomicResultPrintableUri,
  AtomicResultRating as LitAtomicResultRating,
  AtomicResultSectionActions as LitAtomicResultSectionActions,
  AtomicResultSectionBadges as LitAtomicResultSectionBadges,
  AtomicResultSectionBottomMetadata as LitAtomicResultSectionBottomMetadata,
  AtomicResultSectionChildren as LitAtomicResultSectionChildren,
  AtomicResultSectionEmphasized as LitAtomicResultSectionEmphasized,
  AtomicResultSectionExcerpt as LitAtomicResultSectionExcerpt,
  AtomicResultSectionTitle as LitAtomicResultSectionTitle,
  AtomicResultSectionTitleMetadata as LitAtomicResultSectionTitleMetadata,
  AtomicResultSectionVisual as LitAtomicResultSectionVisual,
  AtomicResultsPerPage as LitAtomicResultsPerPage,
  AtomicResultText as LitAtomicResultText,
  AtomicResultTimespan as LitAtomicResultTimespan,
  AtomicSearchBox as LitAtomicSearchBox,
  AtomicSearchBoxInstantResults as LitAtomicSearchBoxInstantResults,
  AtomicSearchBoxQuerySuggestions as LitAtomicSearchBoxQuerySuggestions,
  AtomicSearchBoxRecentQueries as LitAtomicSearchBoxRecentQueries,
  AtomicSearchInterface as LitAtomicSearchInterface,
  AtomicSearchLayout as LitAtomicSearchLayout,
  AtomicSegmentedFacet as LitAtomicSegmentedFacet,
  AtomicSegmentedFacetScrollable as LitAtomicSegmentedFacetScrollable,
  AtomicSmartSnippet as LitAtomicSmartSnippet,
  AtomicSmartSnippetFeedbackModal as LitAtomicSmartSnippetFeedbackModal,
  AtomicSmartSnippetSuggestions as LitAtomicSmartSnippetSuggestions,
  AtomicSortDropdown as LitAtomicSortDropdown,
  AtomicSortExpression as LitAtomicSortExpression,
  AtomicTab as LitAtomicTab,
  AtomicTableElement as LitAtomicTableElement,
  AtomicTabManager as LitAtomicTabManager,
  AtomicText as LitAtomicText,
  AtomicTimeframe as LitAtomicTimeframe,
  AtomicTimeframeFacet as LitAtomicTimeframeFacet,
} from '@coveo/atomic/components';
import {createComponent} from '@lit/react';
import React from 'react';

export const AtomicAriaLive = /*@__PURE__*/ createComponent({
  tagName: 'atomic-aria-live',
  react: React,
  elementClass: LitAtomicAriaLive,
});

export const AtomicAutomaticFacet = /*@__PURE__*/ createComponent({
  tagName: 'atomic-automatic-facet',
  react: React,
  elementClass: LitAtomicAutomaticFacet,
});

export const AtomicAutomaticFacetGenerator = /*@__PURE__*/ createComponent({
  tagName: 'atomic-automatic-facet-generator',
  react: React,
  elementClass: LitAtomicAutomaticFacetGenerator,
});

export const AtomicBreadbox = /*@__PURE__*/ createComponent({
  tagName: 'atomic-breadbox',
  react: React,
  elementClass: LitAtomicBreadbox,
});

export const AtomicCategoryFacet = /*@__PURE__*/ createComponent({
  tagName: 'atomic-category-facet',
  react: React,
  elementClass: LitAtomicCategoryFacet,
});

export const AtomicColorFacet = /*@__PURE__*/ createComponent({
  tagName: 'atomic-color-facet',
  react: React,
  elementClass: LitAtomicColorFacet,
});

export const AtomicComponentError = /*@__PURE__*/ createComponent({
  tagName: 'atomic-component-error',
  react: React,
  elementClass: LitAtomicComponentError,
});

export const AtomicDidYouMean = /*@__PURE__*/ createComponent({
  tagName: 'atomic-did-you-mean',
  react: React,
  elementClass: LitAtomicDidYouMean,
});

export const AtomicExternal = /*@__PURE__*/ createComponent({
  tagName: 'atomic-external',
  react: React,
  elementClass: LitAtomicExternal,
});

export const AtomicFacet = /*@__PURE__*/ createComponent({
  tagName: 'atomic-facet',
  react: React,
  elementClass: LitAtomicFacet,
});

export const AtomicFacetManager = /*@__PURE__*/ createComponent({
  tagName: 'atomic-facet-manager',
  react: React,
  elementClass: LitAtomicFacetManager,
});

export const AtomicFocusTrap = /*@__PURE__*/ createComponent({
  tagName: 'atomic-focus-trap',
  react: React,
  elementClass: LitAtomicFocusTrap,
});

export const AtomicFoldedResultList = /*@__PURE__*/ createComponent({
  tagName: 'atomic-folded-result-list',
  react: React,
  elementClass: LitAtomicFoldedResultList,
});

export const AtomicFormatCurrency = /*@__PURE__*/ createComponent({
  tagName: 'atomic-format-currency',
  react: React,
  elementClass: LitAtomicFormatCurrency,
});

export const AtomicFormatNumber = /*@__PURE__*/ createComponent({
  tagName: 'atomic-format-number',
  react: React,
  elementClass: LitAtomicFormatNumber,
});

export const AtomicFormatUnit = /*@__PURE__*/ createComponent({
  tagName: 'atomic-format-unit',
  react: React,
  elementClass: LitAtomicFormatUnit,
});

export const AtomicGeneratedAnswer = /*@__PURE__*/ createComponent({
  tagName: 'atomic-generated-answer',
  react: React,
  elementClass: LitAtomicGeneratedAnswer,
});

export const AtomicGeneratedAnswerFeedbackModal = /*@__PURE__*/ createComponent(
  {
    tagName: 'atomic-generated-answer-feedback-modal',
    react: React,
    elementClass: LitAtomicGeneratedAnswerFeedbackModal,
  }
);

export const AtomicHtml = /*@__PURE__*/ createComponent({
  tagName: 'atomic-html',
  react: React,
  elementClass: LitAtomicHtml,
});

export const AtomicIcon = /*@__PURE__*/ createComponent({
  tagName: 'atomic-icon',
  react: React,
  elementClass: LitAtomicIcon,
});

export const AtomicLayoutSection = /*@__PURE__*/ createComponent({
  tagName: 'atomic-layout-section',
  react: React,
  elementClass: LitAtomicLayoutSection,
});

export const AtomicLoadMoreResults = /*@__PURE__*/ createComponent({
  tagName: 'atomic-load-more-results',
  react: React,
  elementClass: LitAtomicLoadMoreResults,
});

export const AtomicNoResults = /*@__PURE__*/ createComponent({
  tagName: 'atomic-no-results',
  react: React,
  elementClass: LitAtomicNoResults,
});

export const AtomicNotifications = /*@__PURE__*/ createComponent({
  tagName: 'atomic-notifications',
  react: React,
  elementClass: LitAtomicNotifications,
});

export const AtomicNumericFacet = /*@__PURE__*/ createComponent({
  tagName: 'atomic-numeric-facet',
  react: React,
  elementClass: LitAtomicNumericFacet,
});

export const AtomicNumericRange = /*@__PURE__*/ createComponent({
  tagName: 'atomic-numeric-range',
  react: React,
  elementClass: LitAtomicNumericRange,
});

export const AtomicPager = /*@__PURE__*/ createComponent({
  tagName: 'atomic-pager',
  react: React,
  elementClass: LitAtomicPager,
});

export const AtomicPopover = /*@__PURE__*/ createComponent({
  tagName: 'atomic-popover',
  react: React,
  elementClass: LitAtomicPopover,
});

export const AtomicQueryError = /*@__PURE__*/ createComponent({
  tagName: 'atomic-query-error',
  react: React,
  elementClass: LitAtomicQueryError,
});

export const AtomicQuerySummary = /*@__PURE__*/ createComponent({
  tagName: 'atomic-query-summary',
  react: React,
  elementClass: LitAtomicQuerySummary,
});

export const AtomicQuickview = /*@__PURE__*/ createComponent({
  tagName: 'atomic-quickview',
  react: React,
  elementClass: LitAtomicQuickview,
});

export const AtomicQuickviewModal = /*@__PURE__*/ createComponent({
  tagName: 'atomic-quickview-modal',
  react: React,
  elementClass: LitAtomicQuickviewModal,
});

export const AtomicRatingFacet = /*@__PURE__*/ createComponent({
  tagName: 'atomic-rating-facet',
  react: React,
  elementClass: LitAtomicRatingFacet,
});

export const AtomicRatingRangeFacet = /*@__PURE__*/ createComponent({
  tagName: 'atomic-rating-range-facet',
  react: React,
  elementClass: LitAtomicRatingRangeFacet,
});

export const AtomicRecsError = /*@__PURE__*/ createComponent({
  tagName: 'atomic-recs-error',
  react: React,
  elementClass: LitAtomicRecsError,
});

export const AtomicRecsInterface = /*@__PURE__*/ createComponent({
  tagName: 'atomic-recs-interface',
  react: React,
  elementClass: LitAtomicRecsInterface,
});

export const AtomicRecsList = /*@__PURE__*/ createComponent({
  tagName: 'atomic-recs-list',
  react: React,
  elementClass: LitAtomicRecsList,
});

export const AtomicRecsResult = /*@__PURE__*/ createComponent({
  tagName: 'atomic-recs-result',
  react: React,
  elementClass: LitAtomicRecsResult,
});

export const AtomicRefineModal = /*@__PURE__*/ createComponent({
  tagName: 'atomic-refine-modal',
  react: React,
  elementClass: LitAtomicRefineModal,
});

export const AtomicRefineToggle = /*@__PURE__*/ createComponent({
  tagName: 'atomic-refine-toggle',
  react: React,
  elementClass: LitAtomicRefineToggle,
});

export const AtomicResult = /*@__PURE__*/ createComponent({
  tagName: 'atomic-result',
  react: React,
  elementClass: LitAtomicResult,
});

export const AtomicResultBadge = /*@__PURE__*/ createComponent({
  tagName: 'atomic-result-badge',
  react: React,
  elementClass: LitAtomicResultBadge,
});

export const AtomicResultChildren = /*@__PURE__*/ createComponent({
  tagName: 'atomic-result-children',
  react: React,
  elementClass: LitAtomicResultChildren,
});

export const AtomicResultChildrenTemplate = /*@__PURE__*/ createComponent({
  tagName: 'atomic-result-children-template',
  react: React,
  elementClass: LitAtomicResultChildrenTemplate,
});

export const AtomicResultDate = /*@__PURE__*/ createComponent({
  tagName: 'atomic-result-date',
  react: React,
  elementClass: LitAtomicResultDate,
});

export const AtomicResultFieldsList = /*@__PURE__*/ createComponent({
  tagName: 'atomic-result-fields-list',
  react: React,
  elementClass: LitAtomicResultFieldsList,
});

export const AtomicResultHtml = /*@__PURE__*/ createComponent({
  tagName: 'atomic-result-html',
  react: React,
  elementClass: LitAtomicResultHtml,
});

export const AtomicResultIcon = /*@__PURE__*/ createComponent({
  tagName: 'atomic-result-icon',
  react: React,
  elementClass: LitAtomicResultIcon,
});

export const AtomicResultImage = /*@__PURE__*/ createComponent({
  tagName: 'atomic-result-image',
  react: React,
  elementClass: LitAtomicResultImage,
});

export const AtomicResultLink = /*@__PURE__*/ createComponent({
  tagName: 'atomic-result-link',
  react: React,
  elementClass: LitAtomicResultLink,
});

export const AtomicResultList = /*@__PURE__*/ createComponent({
  tagName: 'atomic-result-list',
  react: React,
  elementClass: LitAtomicResultList,
});

export const AtomicResultLocalizedText = /*@__PURE__*/ createComponent({
  tagName: 'atomic-result-localized-text',
  react: React,
  elementClass: LitAtomicResultLocalizedText,
});

export const AtomicResultMultiValueText = /*@__PURE__*/ createComponent({
  tagName: 'atomic-result-multi-value-text',
  react: React,
  elementClass: LitAtomicResultMultiValueText,
});

export const AtomicResultNumber = /*@__PURE__*/ createComponent({
  tagName: 'atomic-result-number',
  react: React,
  elementClass: LitAtomicResultNumber,
});

export const AtomicResultPrintableUri = /*@__PURE__*/ createComponent({
  tagName: 'atomic-result-printable-uri',
  react: React,
  elementClass: LitAtomicResultPrintableUri,
});

export const AtomicResultRating = /*@__PURE__*/ createComponent({
  tagName: 'atomic-result-rating',
  react: React,
  elementClass: LitAtomicResultRating,
});

export const AtomicResultSectionActions = /*@__PURE__*/ createComponent({
  tagName: 'atomic-result-section-actions',
  react: React,
  elementClass: LitAtomicResultSectionActions,
});

export const AtomicResultSectionBadges = /*@__PURE__*/ createComponent({
  tagName: 'atomic-result-section-badges',
  react: React,
  elementClass: LitAtomicResultSectionBadges,
});

export const AtomicResultSectionBottomMetadata = /*@__PURE__*/ createComponent({
  tagName: 'atomic-result-section-bottom-metadata',
  react: React,
  elementClass: LitAtomicResultSectionBottomMetadata,
});

export const AtomicResultSectionChildren = /*@__PURE__*/ createComponent({
  tagName: 'atomic-result-section-children',
  react: React,
  elementClass: LitAtomicResultSectionChildren,
});

export const AtomicResultSectionEmphasized = /*@__PURE__*/ createComponent({
  tagName: 'atomic-result-section-emphasized',
  react: React,
  elementClass: LitAtomicResultSectionEmphasized,
});

export const AtomicResultSectionExcerpt = /*@__PURE__*/ createComponent({
  tagName: 'atomic-result-section-excerpt',
  react: React,
  elementClass: LitAtomicResultSectionExcerpt,
});

export const AtomicResultSectionTitle = /*@__PURE__*/ createComponent({
  tagName: 'atomic-result-section-title',
  react: React,
  elementClass: LitAtomicResultSectionTitle,
});

export const AtomicResultSectionTitleMetadata = /*@__PURE__*/ createComponent({
  tagName: 'atomic-result-section-title-metadata',
  react: React,
  elementClass: LitAtomicResultSectionTitleMetadata,
});

export const AtomicResultSectionVisual = /*@__PURE__*/ createComponent({
  tagName: 'atomic-result-section-visual',
  react: React,
  elementClass: LitAtomicResultSectionVisual,
});

export const AtomicResultsPerPage = /*@__PURE__*/ createComponent({
  tagName: 'atomic-results-per-page',
  react: React,
  elementClass: LitAtomicResultsPerPage,
});

export const AtomicResultText = /*@__PURE__*/ createComponent({
  tagName: 'atomic-result-text',
  react: React,
  elementClass: LitAtomicResultText,
});

export const AtomicResultTimespan = /*@__PURE__*/ createComponent({
  tagName: 'atomic-result-timespan',
  react: React,
  elementClass: LitAtomicResultTimespan,
});

export const AtomicSearchBox = /*@__PURE__*/ createComponent({
  tagName: 'atomic-search-box',
  react: React,
  elementClass: LitAtomicSearchBox,
});

export const AtomicSearchBoxInstantResults = /*@__PURE__*/ createComponent({
  tagName: 'atomic-search-box-instant-results',
  react: React,
  elementClass: LitAtomicSearchBoxInstantResults,
});

export const AtomicSearchBoxQuerySuggestions = /*@__PURE__*/ createComponent({
  tagName: 'atomic-search-box-query-suggestions',
  react: React,
  elementClass: LitAtomicSearchBoxQuerySuggestions,
});

export const AtomicSearchBoxRecentQueries = /*@__PURE__*/ createComponent({
  tagName: 'atomic-search-box-recent-queries',
  react: React,
  elementClass: LitAtomicSearchBoxRecentQueries,
});

export const AtomicSearchInterface = /*@__PURE__*/ createComponent({
  tagName: 'atomic-search-interface',
  react: React,
  elementClass: LitAtomicSearchInterface,
});

export const AtomicSearchLayout = /*@__PURE__*/ createComponent({
  tagName: 'atomic-search-layout',
  react: React,
  elementClass: LitAtomicSearchLayout,
});

export const AtomicSegmentedFacet = /*@__PURE__*/ createComponent({
  tagName: 'atomic-segmented-facet',
  react: React,
  elementClass: LitAtomicSegmentedFacet,
});

export const AtomicSegmentedFacetScrollable = /*@__PURE__*/ createComponent({
  tagName: 'atomic-segmented-facet-scrollable',
  react: React,
  elementClass: LitAtomicSegmentedFacetScrollable,
});

export const AtomicSmartSnippet = /*@__PURE__*/ createComponent({
  tagName: 'atomic-smart-snippet',
  react: React,
  elementClass: LitAtomicSmartSnippet,
});

export const AtomicSmartSnippetFeedbackModal = /*@__PURE__*/ createComponent({
  tagName: 'atomic-smart-snippet-feedback-modal',
  react: React,
  elementClass: LitAtomicSmartSnippetFeedbackModal,
});

export const AtomicSmartSnippetSuggestions = /*@__PURE__*/ createComponent({
  tagName: 'atomic-smart-snippet-suggestions',
  react: React,
  elementClass: LitAtomicSmartSnippetSuggestions,
});

export const AtomicSortDropdown = /*@__PURE__*/ createComponent({
  tagName: 'atomic-sort-dropdown',
  react: React,
  elementClass: LitAtomicSortDropdown,
});

export const AtomicSortExpression = /*@__PURE__*/ createComponent({
  tagName: 'atomic-sort-expression',
  react: React,
  elementClass: LitAtomicSortExpression,
});

export const AtomicTab = /*@__PURE__*/ createComponent({
  tagName: 'atomic-tab',
  react: React,
  elementClass: LitAtomicTab,
});

export const AtomicTableElement = /*@__PURE__*/ createComponent({
  tagName: 'atomic-table-element',
  react: React,
  elementClass: LitAtomicTableElement,
});

export const AtomicTabManager = /*@__PURE__*/ createComponent({
  tagName: 'atomic-tab-manager',
  react: React,
  elementClass: LitAtomicTabManager,
});

export const AtomicText = /*@__PURE__*/ createComponent({
  tagName: 'atomic-text',
  react: React,
  elementClass: LitAtomicText,
});

export const AtomicTimeframe = /*@__PURE__*/ createComponent({
  tagName: 'atomic-timeframe',
  react: React,
  elementClass: LitAtomicTimeframe,
});

export const AtomicTimeframeFacet = /*@__PURE__*/ createComponent({
  tagName: 'atomic-timeframe-facet',
  react: React,
  elementClass: LitAtomicTimeframeFacet,
});
